import { render, staticRenderFns } from "./finance.vue?vue&type=template&id=77f96584&"
import script from "./finance.vue?vue&type=script&lang=js&"
export * from "./finance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports